<template>
  <div>
  <el-select
    name="industry"
    v-validate="{required: true}"
    placeholder="Select"
    filterable
    prefix-icon="el-icon-search" 
    remote
    :remote-method="industrySearch"
    default-first-option
    :allow-create="false"
    v-model="industry"
    :value="industry ? industry.id : null"
    :loading="loadingIndustry"
    v-loading="loadingIndustry"
    element-loading-spinner="qc-spinner"
    :class="{'has-error': errors.has('industry')}"
    value-key="id"
    class="verification-select"
    @input="$emit('input', $event)" >
    <el-option-group v-if="industryOptions != null && industryOptions.length > 0" :label="'Type to search and select an option below'">
      <el-option
        v-for="item in industryOptions"
        :key="item.id"
        :label="item.name"
        :value="item">
      </el-option>
    </el-option-group>
  </el-select>
  <small class="text-danger" v-show="errors.has('industry')">
    {{ errors.first('industry') }}
  </small>
  </div>
</template>

<script>
export default {
  name: 'industry-select',
  inject: ['$validator'],
  props: {
    value: Object,
  },
  data () {
    return {
      industry: this.value,
      loadingIndustry: false,
      industryOptions: this.value ? [this.value] : []
    }
  },
  mounted () {
    this.industrySearch('')
  },
  activated () {
    this.industrySearch('')
  },
  methods: {
    industrySearch(query) {
      if(query != null) {
        this.loadingIndustry = true
        this.doIndustrySearch(query)
      }
    },
    doIndustrySearch:_.debounce(function(query) {
      this.$api.searchAccountIndustries(query)
        .then(response => {
          this.industryOptions = response.data.filter(i => i.id != -1)
          this.loadingIndustry = false
        })
        .catch(error => {
          console.log("Failed to load industries")
          this.loadingIndustry = false
        })  
    }, 200)
  }
}
</script>